"use strict";
const Promise = require('bluebird');
const actionTypes = require('../actionTypes');
const api = require('../api');
exports.startListeningToTasks = (user) => (dispatch) => {
    const ref = api.database.listenToTasks(user.uid, (event, taskOrTaskId) => {
        switch (event) {
            case 'child_added':
                dispatch(taskAdded(taskOrTaskId));
                return;
            case 'child_changed':
                dispatch(taskChanged(taskOrTaskId));
                return;
            case 'child_removed':
                dispatch(taskRemoved(taskOrTaskId));
                return;
            default:
                throw new Error('unknown event emitted by listenToTasks');
        }
    });
    dispatch({
        type: actionTypes.LISTEN_TO_TASKS,
        ref,
    });
};
const taskAdded = (task) => ({
    type: actionTypes.TASK_ADDED,
    task,
});
const taskChanged = (task) => ({
    type: actionTypes.TASK_CHANGED,
    task,
});
const taskRemoved = (taskId) => ({
    type: actionTypes.TASK_REMOVED,
    taskId,
});
exports.stopListeningToTasks = () => (dispatch, getState) => {
    const { tasksRef } = getState().tasks;
    if (tasksRef) {
        api.database.stopListeningToTasks(tasksRef);
        dispatch({ type: actionTypes.STOP_LISTENING_TO_TASKS });
    }
};
exports.saveTask = (task) => (dispatch, getState) => {
    // Task will be assigned an id by saveTask.
    api.database.saveTask(getState().auth.user.uid, task)
        .catch(error => {
        dispatch(exports.saveTaskError(error));
    });
    return Promise.resolve(task);
};
exports.saveTaskError = (error) => ({
    type: actionTypes.SAVE_TASK_ERROR,
    error,
});
exports.deleteTask = (task) => (dispatch, getState) => api.database.deleteTask(getState().auth.user.uid, task).catch((error) => dispatch(deleteTaskError(error, task)));
const deleteTaskError = (error, task) => ({
    type: actionTypes.DELETE_TASK_ERROR,
    task,
    error,
});
exports.startTask = (task) => (dispatch, getState) => {
    api.database.startTask(getState().auth.user.uid, task)
        .catch(error => dispatch(startTaskError(error)));
};
const startTaskError = (error) => ({
    type: actionTypes.START_TASK_ERROR,
    error,
});
exports.stopTask = (task) => (dispatch, getState) => {
    api.database.stopTask(getState().auth.user.uid, task)
        .catch(error => dispatch(stopTaskError(error)));
};
const stopTaskError = (error) => ({
    type: actionTypes.STOP_TASK_ERROR,
    error,
});



/** WEBPACK FOOTER **
 ** ./src/actions/tasks.ts
 **/